export const getAvatarInitials = (name: string) => {
  const words = name.trim().split(/\s+/);
  const initials: string[] = [];

  // Helper function to find first alphanumeric character in a string
  const getFirstAlphanumeric = (str: string): string | null => {
    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      if (/[a-zA-Z0-9]/.test(char)) {
        return char.toUpperCase();
      }
    }
    return null;
  };

  // Try to get initials from the first two words
  for (let i = 0; i < words.length && initials.length < 2; i++) {
    const initial = getFirstAlphanumeric(words[i]);
    if (initial) {
      initials.push(initial);
    }
  }

  // If we only got one initial from multiple words, or if there's only one word,
  // try to get a second character from the remaining characters of the first word
  if (initials.length === 1 && words.length > 0) {
    const firstWord = words[0];
    let foundFirst = false;

    for (let i = 0; i < firstWord.length; i++) {
      const char = firstWord[i];
      if (/[a-zA-Z0-9]/.test(char)) {
        if (foundFirst) {
          // This is the second alphanumeric character
          initials.push(char.toUpperCase());
          break;
        }
        foundFirst = true;
      }
    }
  }

  // Return the initials, or fallback to '?' if none found
  return initials.length > 0 ? initials.join('') : '?';
};

export const splitContentInHalf = (content: string) => {
  const half = Math.round(content.length / 2);
  const first = content.substring(0, half);
  const last = content.substring(half, content.length);

  return [first, last];
};

// Does not account for 'ies' type of pluralization
// Good: ("item", count):
// "1 item"
// "2 items"
// Bad: ("cherry", count):
// "1 cherry"
// "2 cherrys" instead of "2 cherries"
export const pluralize = (content: string, count: number) =>
  count === 1 ? content : `${content}s`;

export const isHtmlContainingAttribute = (
  html: string | undefined,
  tagName: string,
  key: string,
  value: string
): boolean => {
  if (!html) {
    return false;
  }

  // Use a dynamic regular expression where tagName, key, and value are variables
  const regex = new RegExp(`<${tagName}[^>]*\\b${key}="${value}"[^>]*>`);
  return regex.test(html);
};

const _detectUnicode = (char: string): boolean => {
  return char > '~'; // '~' has a Unicode value of 126
};

export const isUnicode = (str: string): boolean => {
  return Array.from(str).some(_detectUnicode);
};
